export default __webpack_public_path__ + "static/media/icon-arrow-left-green.318139c9.svg";